import type { Colors, DefaultTheme } from 'styled-components';
import { lightColors, mapLightTheme } from './LightTheme';

const colors: Colors = {
  ...lightColors,
  primary: {
    lighten: '#5672ff',
    default: '#2348ff',
    dim: 'rgba(35,72,255,0.4)',
    mute: 'rgba(35,72,255,0.1)',
  },
  gray: {
    '100': '#1d1d28',
    '000': '#e6e6e7',
    '010': '#f2f2f3',
    main: '#ffffff',
    '020': '#fafafa',
    '030': '#ebebeb',
    '040': '#dbdbdd',
    '050': '#d2d2d4',
    '060': '#c8c8ca',
    '070': '#bbbbbe',
    '080': '#9b9b9f',
    '090': '#696970',
  },
  green: {
    lighten: '#27ce5d',
    default: '#1fa34a',
    dim: 'rgba(31,163,74,0.4)',
    mute: 'rgba(31,163,74,0.1)',
  },
  red: {
    lighten: '#df6460',
    default: '#d73a35',
    dim: 'rgba(215,58,53,0.4)',
    mute: 'rgba(215,58,53,0.1)',
  },
  yellow: {
    lighten: '#ef7a2a',
    default: '#d66010',
    dim: 'rgba(214,96,16,0.4)',
    mute: 'rgba(214,96,16,0.1)',
  },
  orange: {
    lighten: '#ed8c48',
    default: '#e86f1a',
    dim: 'rgba(232,111,26,0.4)',
    mute: 'rgba(232,111,26,0.1)',
  },
  blue: {
    lighten: '#5fa2e7',
    default: '#3388E0',
    dim: 'rgba(51,136,224,0.4)',
    mute: 'rgba(51,136,224,0.1)',
  },
  purple: {
    lighten: '#9f73d7',
    default: '#844BCC',
  },
  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#1a1a1a',
    dim: 'rgba(26,26,26,0.4)',
    mute: 'rgba(26,26,26,0.1)',
  },
};

export const LightCoinhakoTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightCh',

  colorTextDefaultButton: '#1a1a1a',
  colorTextDefaultButtonHover: '#1a1a1a',
  colorTextDefaultButtonFocus: '#1a1a1a',
  colorTextDefaultButtonActive: '#1a1a1a',
  colorTextDefaultButtonDisabled: 'rgba(26,26,26,0.5)',

  colorTextPositiveButton: '#1a1a1a',
  colorTextPositiveButtonHover: '#1a1a1a',
  colorTextPositiveButtonFocus: '#1a1a1a',
  colorTextPositiveButtonActive: '#1a1a1a',
  colorTextPositiveButtonDisabled: 'rgba(26,26,26,0.5)',

  colorTextWarningButton: '#1a1a1a',
  colorTextWarningButtonHover: '#1a1a1a',
  colorTextWarningButtonFocus: '#1a1a1a',
  colorTextWarningButtonActive: '#1a1a1a',
  colorTextWarningButtonDisabled: 'rgba(26,26,26,0.5)',

  colorTextMutedButton: '#1a1a1a',
  colorTextMutedButtonHover: '#1a1a1a',
  colorTextMutedButtonFocus: '#1a1a1a',
  colorTextMutedButtonActive: '#1a1a1a',
  colorTextMutedButtonDisabled: 'rgba(26,26,26,0.5)',
});
